import { API } from '~apis/axios/instance';
import { ResponseBaseWithData } from '~types/response';

export interface TrendsResponse {
  checking: ITrendsItem[];
  overdraft: ITrendsItem[];
  saving: ITrendsItem[];
  fx: ITrendsItem[];
  security: ITrendsItem[];
}
export interface ITrendsItem {
  date: string;
  balance: number;
}

export const getTrends = ({
  companyId,
  startDate,
  endDate,
}: {
  companyId: string;
  startDate: string;
  endDate: string;
}) => {
  return API.get<ResponseBaseWithData<TrendsResponse>>(
    `/api/v3/companies/${companyId}/cashflow-overview/trends`,
    {
      params: {
        startDate,
        endDate,
      },
    },
  );
};
